<template>
  <div class="v-if-wrapepr">
    <div class="App-usage bg-white" v-if="!isAfter(date_now, show_twitter)">
      <div class="inner text-center">
        <h1 class="h1 title">{{$t('usage.title')}}</h1>
        <div class="content text-left">
          <div class="gray">
            <div class="title-mini">{{$t('usage.title1')}}</div>
            <div class="text white-space-pre-wrap first">{{$t('usage.text1')}}</div>
            <div class="title-mini">{{$t('usage.title2')}}</div>
            <div class="text white-space-pre-wrap last">{{$t('usage.text2')}}</div>
            <div class="date2 title-mini child-span-red" v-html="$sanitize($t('usage.date'))"></div>
            <div class="title-mini text-red">注意事項</div>
            <div class="caption white-space-pre-wrap" v-html="$t('usage.caption3')"></div>
            <!--再募集-->
            <div class="beta_end text-center" v-if="isAfter(date_now, sai_test_start)">{{ $t('top.beta_end') }}</div>
            <div class="btn-wrapper" v-else-if="isAfter(date_now, sai_boshu)">
              <button class="btn btn-red text-white d-block wmin-160 wmin-md-222 position-relative" @click="contact">{{$t('btn.beta')}}<span class="arrow border-white ml-7"></span></button>
            </div>
            <div class="beta_end text-center" v-else-if="isAfter(date_now, end_date)">{{ $t('top.beta_end') }}</div>
            <div class="btn-wrapper" v-else>
              <button class="btn btn-red text-white d-block wmin-160 wmin-md-222 position-relative" @click="contact">{{$t('btn.beta')}}<span class="arrow border-white ml-7"></span></button>
            </div>
          </div>
        </div>
        <div class="faq" v-show="only_beta.length > 0">
          <div class="inner text-center">
            <h1 class="h1 title">{{ $t('usage.title_faq') }}</h1>
            <div class="content text-left">
              <faq></faq>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="App-error bg-white" v-else>
      <div class="inner text-center">
        <div class="content">
          <div class="main">{{$t('error.main')}}</div>
          <div class="sub">{{$t('error.sub')}}</div>
          <div class="lead white-space-pre-wrap" v-html="$t('error.lead')"></div>
          <div class="btn-wrapper">
            <router-link class="btn btn-red" :to="{'name':'home.index'}">{{$t('btn.back_complete')}}</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex'
  import { META_USAGE } from '../../mixins/metadata.js'
  import Faq from './component/faq.vue'

  export default {
    mixins: [META_USAGE],
    components: {
      'faq': Faq,
    },
    name: 'UsagePage',
    head: {
      title: {
        inner: 'β版のご利用方法｜思いがけないアイデアと出会う。プロフェッショナル同士の予定調和のない雑談'
      },
      meta: [
        { name: 'keywords', content: '思いがけないアイデアと出会う。プロフェッショナル同士の予定調和のない雑談' },
        { name: 'description', content: '思いがけないアイデアと出会う。プロフェッショナル同士の予定調和のない雑談' },
      ]
    },
    data() {
      return {
        date_now: this.$moment().format(),
        end_date: this.$moment('2020-12-28T11:59:59+09:00').format(),
        sai_boshu: this.$moment('2021-01-13T11:59:59+09:00').format(),
        sai_test_start: this.$moment('2021-01-29T11:59:59+09:00').format(),
        show_twitter: this.$moment('2021-01-31T23:59:59+09:00').format(),
      }
    },
    methods: {
      contact() {
        const url = 'https://docs.google.com/forms/d/e/1FAIpQLSeFXav1zSxAY-qzD2ReO5-L4znlVCXqD4fB_OY28Ko66VW-5w/viewform'
        window.open(url, '_blank')
      },
      isAfter(dateNow, endDate) {
        return this.$route.query.time ? this.$moment(this.$route.query.time).isAfter(endDate) : this.$moment(dateNow).isAfter(endDate)
      }
    },
    computed: {
      ...mapGetters('faq', ['only_beta']),
    },
  }
</script>
